import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-shorts-error-dialog',
  templateUrl: './shorts-error-dialog.component.html',
  styleUrls: ['./shorts-error-dialog.component.css']
})
export class ShortsErrorDialogComponent implements OnInit {

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<ShortsErrorDialogComponent>) { }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close(true);
  }

}
